import styled from 'styled-components';
import InfiniteScroll from 'react-infinite-scroll-component';
import { Flex, FlexCenterBoth } from 'components/primitives/flex';
import Tooltip from 'components/ui/Tooltip/Tooltip';
import { sortConvos } from 'stacks/messaging/helpers';
import { renderConversationItem } from './ConversationItem';
import { Loader } from './commons';
import useMessagesFilterSelectedValues from './hooks/useMessagesFilterSelectedValues';
import ArchivedInfoText from './ArchivedInfoText';

export default function ConversationsTabContent({ queryObject, 'data-testid': dataTestId = undefined }) {
  const { pages, fetchNextPage, hasNextPage, isLoading } = queryObject;

  const { isArchiveFilterSelected, isUnreadMessagesFilterSelected, isReadMessagesFilterSelected, isAllFilterSelected } =
    useMessagesFilterSelectedValues();

  if (isLoading) {
    return null;
  }

  if (pages.length <= 1 && pages[0]?.data.length === 0) {
    return (
      <FlexCenterBoth py="4em" data-testid={`${dataTestId}_empty`}>
        {isArchiveFilterSelected && <ArchivedInfoText />}
        {isUnreadMessagesFilterSelected && 'You don’t have any unread messages'}
        {isReadMessagesFilterSelected && 'You don’t have any read messages'}
        {isAllFilterSelected && (
          <Flex gap="5px">
            You don’t have any messages here
            <Tooltip
              triggerWith={
                <svg fill="#0751c2" height={20} width={20} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1008 1008">
                  <path d="M504 980.2C239.9 980.2 27.8 768.1 27.8 504S239.9 27.8 504 27.8 980.2 239.9 980.2 504 768.1 980.2 504 980.2zm0-887.4C274.6 92.8 92.8 274.6 92.8 504S274.6 915.2 504 915.2 915.2 733.4 915.2 504 733.4 92.8 504 92.8zm34.6 467.5v30.3c0 17.3-13 34.6-34.6 34.6s-34.6-13-34.6-34.6v-51.9c0-13 4.3-21.6 13-26h4.3l34.6-17.3h8.7c4.3 0 8.7-4.3 8.7-4.3 43.3-17.3 56.3-34.6 56.3-73.6 0-51.9-43.3-90.9-95.2-90.9-43.3 0-82.2 30.3-95.2 69.3 0 8.7-17.3 21.6-34.6 17.3-17.3-8.7-26-26-21.6-43.3C365.7 300.6 430.6 253 504.2 253c90.9 0 160.2 69.3 160.2 155.8 0 69.3-30.3 108.2-95.2 134.2-4.3 0-8.7 4.3-13 4.3h-8.6c-4.6 8.6-9 8.6-9 13zM504 755.1c-21.6 0-39-17.3-39-39s17.3-39 39-39 39 17.3 39 39-17.4 39-39 39z" />
                </svg>
              }
            >
              Can&apos;t find your messages? <br /> Check the message filter above.
            </Tooltip>
          </Flex>
        )}
      </FlexCenterBoth>
    );
  }

  return (
    <div data-testid={dataTestId}>
      <StyledInfiniteScroll
        data-testid={`${dataTestId}_infinite-scroll`}
        dataLength={pages.length}
        next={fetchNextPage}
        scrollableTarget="inboxMessagesPanel"
        loader={<Loader />}
        hasMore={hasNextPage}
      >
        {pages.map(({ data }) => sortConvos(data || []).map(renderConversationItem))}
      </StyledInfiniteScroll>
    </div>
  );
}

const StyledInfiniteScroll = styled(InfiniteScroll)`
  overflow: hidden !important;
`;
